module.exports = __webpack_public_path__ + "media/images/brands/crosspoint_icon_black-f8aa594f7b10de0dbd10855b7d8f823a.svg";